import { ChevronDownIcon, ChevronUpIcon } from "@xola/icons";
import { SecondaryButton } from "common";
import React, { useEffect, useState } from "react";
import { useDashboardFilterStore } from "@/stores/dashboardFilterStore";

export const CollapseHeaderComponent = ({ api, context }: any) => {
    const { showExpandCollapseHeader, setExpanded, isExpanded } = context;
    const expandAllRows = useDashboardFilterStore((state) => state.displayOptions.expandAllRows);
    const [expandedState, setExpandedState] = useState<boolean>(isExpanded ?? expandAllRows);

    useEffect(() => {
        setExpandedState(isExpanded ?? expandAllRows);
    }, [isExpanded, expandAllRows]);

    const toggleExpand = () => {
        if (expandedState) {
            api.collapseAll();
        } else {
            api.expandAll();
        }
        api.resetRowHeights();
        setExpanded(!expandedState);
        setExpandedState(!expandedState);
    };

    if (!showExpandCollapseHeader) return null;

    return (
        <SecondaryButton size="small" className="m-auto h-[26px] w-[26px] items-center text-sm" onClick={toggleExpand}>
            {expandedState ? (
                <div className="flex flex-col">
                    <ChevronDownIcon className="h-2 w-2" />
                    <ChevronUpIcon className="h-2 w-2" />
                </div>
            ) : (
                <div className="flex flex-col">
                    <ChevronUpIcon className="h-2 w-2" />
                    <ChevronDownIcon className="h-2 w-2" />
                </div>
            )}
        </SecondaryButton>
    );
};
